export const SET_DARK_MODE = 'SET_DARK_MODE';

export const setDark = (value) => ({
  type: SET_DARK_MODE,
  payload: value,
});
